module.exports = __webpack_public_path__ + "static/media/slide-4.d9aa2db6.jpg";